import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p className="footer__title">© 2021 Mesto Russia</p>
    </footer>
  );
}

export default Footer;